
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lectures",
      function () {
        return require("private-next-pages/lectures.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lectures"])
      });
    }
  